//转换日期格式
export const changeDataType = (text) => {
  // 2022-07-18 09:53
  let year = text.substring(0, 4);
  let mon = text.substring(5, 7);
  let day = text.substring(8, 10);
  let time = text.substring(11);
  let date = year + '年' + mon + '月' + day + '日';
  return { date: date, time: time };
}



export const drawImgLine = (value, type, c) => {
  //type 1  AI识别的  2原图
  let amuXArr = [];
  let amuYArr = [];
  for (const item of value.point_latlng) {
    if (item) {
      amuXArr.push(
        item["latitude"]
      )
      amuYArr.push(
        -1 * item["longitude"]
      )
    }
  }

  let droneamuXArr = [];
  let droneamuYArr = [];
  for (const item of value.lnglats) {
    if (item) {
      droneamuXArr.push(
        item["latitude"]
      )
      droneamuYArr.push(
        -1 * item["longitude"]
      )
    }
  }

  const canvasWidth = 960;
  const canvasHeight = 720;

  // 拿到方向轴的最大最小值
  let xMax = Math.max(...droneamuXArr);
  let xMin = Math.min(...droneamuXArr);
  let yMax = Math.max(...droneamuYArr);
  let yMin = Math.min(...droneamuYArr);


  // 根据canvas宽高计算缩放级别
  let size = value['size'];
  let idx = value['idx'];
  let angle = value['yaw'];
  let localpic = value['localpic'];
  let xScale = canvasWidth / (xMax - xMin);
  let yScale = canvasHeight / (yMax - yMin);
  let scale1 = xScale < yScale ? xScale * size : yScale * size;

  //console.log("-" + size + "_" + angle);

  // 计算偏移量
  let xoffset = (canvasWidth - (xMax - xMin) * scale1) / 2;
  let yoffset = (canvasHeight - (yMax - yMin) * scale1) / 2;

  //console.log(xoffset + "|" + yoffset + "|" + idx);

  if (type === 1) {
    // var canvas = document.getElementById('posiToShape');

    let canvas = document.createElement('canvas');
    canvas.width = "960"
    canvas.height = "720"
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);//清空画布
    let img = document.createElement("img");
    img.src = value.AipicUrl;
    // let pic = require( '../img/pic.jpg');
    // img.src = pic;
    img.onload = function () {
      ctx.beginPath();
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
      ctx.stroke();
      ctx.save();//保存状态

      ctx.strokeStyle = "#00b5ff";
      ctx.lineWidth = 5;

      //焦点移动到图像中心
      ctx.translate(((droneamuXArr[4] - xMin) * scale1 + xoffset), ((yMax - droneamuYArr[4]) * scale1 + yoffset));
      //旋转到对应的角度
      ctx.rotate(((90) + (360 - angle) - 180) * Math.PI / 180);

      //绘制管线
      for (let i = 0; i < amuXArr.length; i++) {
        ctx.lineTo(
          (((amuXArr[i] - xMin) * scale1 + xoffset) - ((droneamuXArr[4] - xMin) * scale1 + xoffset)),
          (((yMax - amuYArr[i]) * scale1 + yoffset) - ((yMax - droneamuYArr[4]) * scale1 + yoffset))
        );
      }
      ctx.stroke();
      ctx.closePath();
      return c(canvas.toDataURL());
    }
  } else {
    // var canvas = document.getElementById('posiToShape2');
    let canvas = document.createElement('canvas');
    canvas.width = "960"
    canvas.height = "720"
    let ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);//清空画布
    let img = document.createElement("img");
    img.src = value.picUrl;
    // let pic = require( '../img/pic.jpg');
    // img.src = pic;
    img.onload = function () {
      ctx.beginPath();
      ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
      ctx.stroke();
      ctx.save();//保存状态

      ctx.strokeStyle = "#00b5ff";
      ctx.lineWidth = 5;

      //焦点移动到图像中心
      ctx.translate(((droneamuXArr[4] - xMin) * scale1 + xoffset), ((yMax - droneamuYArr[4]) * scale1 + yoffset));
      //旋转到对应的角度
      ctx.rotate(((90) + (360 - angle) - 180) * Math.PI / 180);

      //绘制管线
      for (let i = 0; i < amuXArr.length; i++) {
        ctx.lineTo(
          (((amuXArr[i] - xMin) * scale1 + xoffset) - ((droneamuXArr[4] - xMin) * scale1 + xoffset)),
          (((yMax - amuYArr[i]) * scale1 + yoffset) - ((yMax - droneamuYArr[4]) * scale1 + yoffset))
        );
      }
      ctx.stroke();
      ctx.closePath();
      return c(canvas.toDataURL());
    }
  }

}

const PI = 3.14159265358979324;
const a = 6378245.0;
const ee = 0.00669342162296594323;

function delta (lat, lon) {
  let a = 6378245.0 //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
  let ee = 0.00669342162296594323 //  ee: 椭球的偏心率。
  let dLat = transformLat(lon - 105.0, lat - 35.0)
  let dLon = transformLon(lon - 105.0, lat - 35.0)
  let radLat = lat / 180.0 * PI
  let magic = Math.sin(radLat)
  magic = 1 - ee * magic * magic
  let sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI)
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI)
  return {
    'lat': dLat,
    'lon': dLon
  }
}

function transformLat (x, y) {
  let ret = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0
  ret += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0
  return ret
}


function transformLon (x, y) {
  let ret = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
  ret += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0
  ret += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0
  ret += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0
  return ret
}

/*判断是否在国内，不在国内则不做偏移*/
function outOfChina (lon, lat) {
  if ((lon < 72.004 || lon > 137.8347) && (lat < 0.8293 || lat > 55.8271)) {
    return true;
  } else {
    return false;
  }
}


//GCJ02坐 标转 WGS84坐标
export const transformGCJ2WGS = (value, c) => {
  let d = delta(Number(value.lat), Number(value.lon))
  return {
    'lat': Number(value.lat) - Number(d.lat),
    'lon': Number(value.lon) - Number(d.lon)
  }
}


// WGS84坐标 转 GCJ02坐标 
export const transformWGSGCJ2 = (wgLat, wgLon) => {
  var mars_point = { lon: 0, lat: 0 };
  // if (outOfChina(wgLat, wgLon))
  // {
  //     mars_point.lat = wgLat;
  //     mars_point.lon = wgLon;
  //     return;
  // }
  var dLat = transformLat(Number(wgLon) - 105.0, Number(wgLat) - 35.0);
  var dLon = transformLon(Number(wgLon) - 105.0, Number(wgLat) - 35.0);
  var radLat = Number(wgLat) / 180.0 * PI;
  var magic = Math.sin(radLat);
  magic = 1 - ee * magic * magic;
  var sqrtMagic = Math.sqrt(magic);
  dLat = (dLat * 180.0) / ((a * (1 - ee)) / (magic * sqrtMagic) * PI);
  dLon = (dLon * 180.0) / (a / sqrtMagic * Math.cos(radLat) * PI);
  mars_point.lat = Number(wgLat) + dLat;
  mars_point.lon = Number(wgLon) + dLon;
  return mars_point
}

/**
 * 计算两个经纬度之间的距离 单位 m
 * @param {Array} point1 [lon,lat]
 * @param {Array} point2 [lon,lat]
 * @param {Number} radius 
 * @returns 
 */
export const distance = (point1, point2, radius = 6378.137) => {
  if (point1[0] === point2[0] && point1[1] === point2[1]) {
    return 0
  } else {
    let rad = Number(Math.PI / 180.0);
    let lat1 = Number(point1[1]) * rad;
    let lon1 = Number(point1[0]) * rad;
    let lat2 = Number(point2[1]) * rad;
    let lon2 = Number(point2[0]) * rad;
    let theta = lon2 - lon1;
    let dist = Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(theta));
    if (dist < 0) {
      dist = dist + Math.PI;
    }
    let val = dist * radius * 1000;
    return val
  }

}


// 将扁平化数据修改为树结构
/**
 * 
 * @param {Array} data  扁平化数组
 * @param {String} pid  父id
 * @param {String} cid  当前id
 * @returns 
 */
export const getTreeDataByDelayeringData = (arr, pid, cid) => {
  // let arr = JSON.parse(JSON.stringify(data).replaceAll(pid, 'parentId').replaceAll(cid, 'currentId'))
  arr.forEach(function (item) { delete item.children })
  let map = {}
  arr.forEach(i => { map[i[cid]] = i; })
  let treeData = []
  arr.forEach(child => {
    const mapItem = map[child[pid]]
    if (mapItem) {
      (mapItem.children || (mapItem.children = [])).push(child)
    } else {
      treeData.push(child)
    }
  })
  return treeData
}



// 替换所有字符串
/**
* 
* @param {String} f 需要替换的字符
* @param {String} e 替换后的字符
* @returns 
*/
// eslint-disable-next-line
String.prototype.replaceAll = function (f, e) { //吧f替换成e
  var reg = new RegExp(f, "g"); //创建正则RegExp对象   
  return this.replace(reg, e);
}


//防抖
export const debounce = (func, delay) => {
  let timer = null;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}


//字符串转数值
export const stringToNumber = (value) => {
  if (value.toString()) {
    // eslint-disable-next-line
    let text = value.toString().replace(/[^\d\.]/g, '')
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");//处理字符串中的其他字符串，数字和小数点除外
    return text;
  }
  return value
}

export const calculateNewCoordinates = (lat, lon, distance) => {//已知一个经纬度和半径，求另一个经纬度
  const earthRadius = 6378137; // 地球半径，单位米  
  const latRadA = lat * Math.PI / 180; // 转换为弧度  
  const deltaLat = distance / (earthRadius * Math.PI / 180); // 纬度偏移  
  const deltaLon = distance / (earthRadius * Math.cos(latRadA) * Math.PI / 180); // 经度偏移  

  const newLat = Number((lat + deltaLat).toFixed(6));
  const newLon = Number((lon + deltaLon).toFixed(6));

  return [newLat, newLon]
}


// centerPoint = [31.801674, 106.089901]//二场地址
// centerPoint = [30.8373665, 104.186505]//新都地址
// centerPoint = [29.755115, 107.242228]//涪陵地址
// centerPoint = [37.165382, 118.648997]//清河地址

export const demoMap = (centerPoint) => {//地图资源
  let mapCommon = []//地图瓦片 id

  // 二厂(等待部署的前端)
  // BM.Config.HTTP_URL = 'http://10.18.3.112:81/map';
  // BM.accessToken = 'pk.eyJ1IjoiY3VzXzNvZHlibHg4IiwiYSI6Ijh5dTA3MHIxcG9ibjMyOXplOHphMGI4d3oiLCJ0Ijo0fQ.AbA5tGBCm4LKWUZoTnERdve98kAa5aNK9DI4lTgkktc';
  // let map = BM.map('map', null, { center: centerPoint || [31.801674, 106.089901], zoom: 17, maxZoom: 18, zoomControl: false, attributionControl: false, bigemapLogo: false, })//阆中地图
  // mapCommon = ['bigemap.6opd9fpo', 'bigemap.2fv4s52s',]//将地图id以字符串数组排列

  //二厂（杰哥所需的前端）  
  // BM.Config.HTTP_URL = 'http://192.168.1.199:3000';
  // BM.accessToken = 'pk.eyJ1IjoiY3VzXzNvZHlibHg4IiwiYSI6Ijh5dTA3MHIxcG9ibjMyOXplOHphMGI4d3oiLCJ0Ijo0fQ.AbA5tGBCm4LKWUZoTnERdve98kAa5aNK9DI4lTgkktc';
  // let map = BM.map('map', null, { center: centerPoint, zoom: 17, maxZoom: 24, zoomControl: false, attributionControl: false, bigemapLogo: false, })
  // mapCommon = ['bigemap.37zbi9ac', 'bigemap.ao1qxem7', 'bigemap.1bxa1or5']//将地图id以字符串数组排列

  //  清河
  // BM.Config.HTTP_URL = 'http://10.67.212.36:9000';
  // BM.accessToken = 'pk.eyJ1IjoiY3VzXzg0OGQ2NzlrIiwiYSI6IjI1aTBueGk3bHdtejh3Y294NXM3MnVsZzAifQ.chE2hHUXEYMvAyquI6JuHg';
  // let map = BM.map('map', null, { center: centerPoint || [37.165382, 118.648997], zoom: 11, maxZoom: 24, zoomControl: false, attributionControl: false, bigemapLogo: false, })
  // mapCommon = ['bigemap.40f7bpip', 'bigemap.5ep7x03h', 'bigemap.5t273kn2',]//将地图id以字符串数组排列

  // 涪陵
  // BM.Config.HTTP_URL = 'http://10.85.144.110:9000'
  // BM.accessToken = 'pk.eyJ1IjoiY3VzXzNvZHlibHg4IiwiYSI6Ijh5dTA3MHIxcG9ibjMyOXplOHphMGI4d3oiLCJ0Ijo0fQ.lpKOgFVY6EEQycauNGsEIDXa80dbMoOclBhN32UrmNU'
  // let map = BM.map('map', null, { center: centerPoint || [29.755115, 107.242228], zoom: 11, maxZoom: 24, zoomControl: false, attributionControl: false, bigemapLogo: false, })
  // mapCommon = [
  //   'bigemap.9d91idb3',
  //   'bigemap.bhjsi9ts',
  //   'bigemap.d77xw6u5',
  //   'bigemap.47lgqxrr',
  //   'bigemap.5dy8518a',
  //   'bigemap.akwh6sn6',
  // ]//新服务器所用的key

  // 普光
  // BM.Config.HTTP_URL = 'http://10.80.61.201:9000';
  // BM.accessToken = 'pk.eyJ1IjoiY3VzXzcxaW9iNjY3IiwiYSI6IjM0Z2lkZjFzYjJxdm04N3Fzdm5xeXhuaWEifQ.R4Etg24KY2bmEi_kT5MKpA';
  // let map = BM.map('map', null, { center: centerPoint || [31.569286, 107.75694], zoom: 11, maxZoom: 24, zoomControl: false, attributionControl: false, bigemapLogo: false, })
  // mapCommon = ['bigemap.00k27lst', 'bigemap.39bcb2vg',]//将地图id以字符串数组排列

  // 在线版
  BM.Config.HTTP_URL = 'http://www.bigemap.com:9000';
  let map = BM.map('map', null, { center: centerPoint || [30.8373665, 104.186505], zoom: 17, maxZoom: 24, zoomControl: false, attributionControl: false, });
  mapCommon = ['bigemap.zhongkexingtu']//将地图id以字符串数组排列

  // 本地离线版
  // BM.Config.HTTP_URL = 'http://127.0.0.1:9000';
  // BM.accessToken = 'pk.eyJ1IjoiY3VzX2QwaHVsaXh0IiwiYSI6ImVudjk5Zjdhb2dhemI5cWx4NDZjaDd0eXMifQ.D1uMGsHLHtI66G6BHDcnww';
  // let map = BM.map('map', null, { center: centerPoint || [30.8373665, 104.186505], zoom: 17, maxZoom: 24, zoomControl: false, attributionControl: false, bigemapLogo: false, });
  // mapCommon = ['bigemap.czxtfz3g']//将地图id以字符串数组排列


  //地图放大↓
  let arr = []
  mapCommon.forEach((res, index) => {
    arr[index] = BM.tileLayer(res)
    arr[index].addTo(map)
    arr[index].on('loading', () => {
      Object.assign(arr[index].options, {
        // maxNativeZoom: 17,//当前地图的最大级别  离线版
        maxNativeZoom: 18,//当前地图的最大级别  在线版
        maxZoom: 24,//将地图放大到指定级别
      })
    })
  })
  //地图放大↑

  return map
}

// 获取bigmap海拔
export const getBigmapAltitudeByLngLatApi = async (arr) => {
  let altitude = 0

  try {
    const response = await fetch(`${url}/terprofile/v1/bigemap.903y00vn/${arr[0]},${arr[1]}?access_token=pk.eyJ1IjoiY3VzX2QwaHVsaXh0IiwiYSI6ImVudjk5Zjdhb2dhemI5cWx4NDZjaDd0eXMifQ.D1uMGsHLHtI66G6BHDcnww`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const result = await response.json();
    altitude = result[0].height ? Number(result[0]?.height?.toFixed(1)) : 0
  } catch (error) {
    // setError(error.message);
  } finally {
    // setLoading(false);
  }
  return altitude || 0

}




